module.exports = __webpack_public_path__ + "mobile.a22acb84.webp";